import LoadingSpinner from "../../../../components/LoadingSpinner";
import { useChangePasswordSuccess } from "../hooks/useChangePasswordSuccess";

const ChangePasswordSuccess = () => {
    const { email, password } = useChangePasswordSuccess();

    if (!email || !password) {
        return (
            <div className="w-full h-screen flex items-center justify-center">
                <p>Invalid session. Redirecting...</p>
            </div>
        );
    }

    // ********************************************************************************

    return (
        <div className={`w-full h-screen flex flex-col items-center background-logo`}>
            <div className="w-[90%] h-full md:w-[392px] flex items-center justify-center">
                <div className="w-full py-[20px] bg-white flex flex-col items-center space-y-[20px]">
                    <div className="font-bold text-[30px] leading-[38px] text-center">
                        Nuova password impostata correttamente
                    </div>
                    <div className="font-normal text-[18px] leading-[26px] text-center">
                        Stai per essere reindirizzato alla tua Area Personale
                    </div>
                    <LoadingSpinner />
                </div>
            </div>
        </div>
    )
}

export default ChangePasswordSuccess
